import { motion } from "framer-motion"

export default function Tokenomics(){
    return(
        <div className='md:w-full mt-40 space-y-20 text-white font-Londrina flex flex-col items-center md:px-60'>
            <div className="md:px-20 md:py-10 bg-cyan-400 bg-opacity-75 border-2 rounded-3xl">
                <div className="flex items-center">
                    <img className="md:w-1/2 w-80 h-80" src={require("../assets/tokenomics.png")}  alt="tokenomics chart" />
                    <div className='text-8xl md:w-1/2'>
                        TOKENOMICS
                        <div className="text-5xl">
                            85% LP <br></br>10% TREASURY<br></br>5% BURNED
                        </div>
                    </div>
                </div>

                <div className="text-5xl text-center space-x-5 flex items-center">
                    <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className="md:w-1/2 text-pink-500 bg-white bg-opacity-75 rounded-3xl">CONTRACT RENOUNCED</motion.button>
                    <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className="md:w-1/2 text-pink-500 bg-white bg-opacity-75 rounded-3xl">LP LOCKED</motion.button>
                </div>
                
            </div>
            
            <div className='w-full mt-20 border-b-2 p-10'></div>
        </div>
    )
}